import * as url from "url";
import { v4 as uuidv4 } from "uuid";
import { Version } from "./Version";

export class NodeId {
  public namespace = "mesutronic.de";
  public identifier: string = uuidv4();
  //
  constructor(namespace?: string, identifier?: string) {
    if (namespace) {
      this.namespace = namespace.toLowerCase();
    }

    if (identifier) {
      this.identifier = identifier.toLowerCase();
    }
  }

  public parseFromUrl(nodeId: string) {
    nodeId = nodeId.toLowerCase();
    const urlNodeId = url.parse(nodeId, true, true);
    this.namespace = urlNodeId.host || "";

    if (urlNodeId != null) {
      const pathsplit = urlNodeId.path?.split("/");
      if (pathsplit != null) {
        if (pathsplit[0] != "") {
          this.identifier = pathsplit[0];
        } else {
          this.identifier = pathsplit[1];
        }
      }
    }
  }

  public toUrl(version?: Version) {
    if (version != null) {
      return (
        "247fn://" +
        this.namespace +
        "/" +
        this.identifier +
        "?version=" +
        version.toString()
      );
    } else {
      return "247fn://" + this.namespace + "/" + this.identifier;
    }
  }
}
